export enum EmploymentEquipmentType {
  TRACTOR_TRAILER = 'TRACTOR_TRAILER',
  RGN = 'RGN',
  STEP_DECK = 'STEP_DECK',
  DRY_VAN = 'DRY_VAN',
  REEFER = 'REEFER',
  TANKER = 'TANKER',
  FLATBED = 'FLATBED',
  BLADE = 'BLADE',
  CONTAINER_CHASSIS = 'CONTAINER_CHASSIS',
  DUMP_TRUCK = 'DUMP_TRUCK',
  SIDE_DUMP = 'SIDE_DUMP',
  BUS = 'BUS',
  STRAIGHT_TRUCK = 'STRAIGHT_TRUCK',
  DOUBLES_AND_TRIPLES = 'DOUBLES_AND_TRIPLES',
  CAR_HAULER = 'CAR_HAULER',
  YARD_TRUCK = 'YARD_TRUCK',
}


export const EmploymentEquipmentTypeLabels: Record<EmploymentEquipmentType, string> = {
  [EmploymentEquipmentType.TRACTOR_TRAILER]: 'Tractor Trailer',
  [EmploymentEquipmentType.RGN]: 'RGN',
  [EmploymentEquipmentType.STEP_DECK]: 'Step Deck',
  [EmploymentEquipmentType.DRY_VAN]: 'Dry Van',
  [EmploymentEquipmentType.REEFER]: 'Reefer',
  [EmploymentEquipmentType.TANKER]: 'Tanker',
  [EmploymentEquipmentType.FLATBED]: 'Flatbed',
  [EmploymentEquipmentType.BLADE]: 'Blade',
  [EmploymentEquipmentType.CONTAINER_CHASSIS]: 'Container/Chassis',
  [EmploymentEquipmentType.DUMP_TRUCK]: 'Dump Truck',
  [EmploymentEquipmentType.SIDE_DUMP]: 'Side Dump',
  [EmploymentEquipmentType.BUS]: 'Bus',
  [EmploymentEquipmentType.STRAIGHT_TRUCK]: 'Straight Truck',
  [EmploymentEquipmentType.DOUBLES_AND_TRIPLES]: 'Doubles And Triples',
  [EmploymentEquipmentType.CAR_HAULER]: 'Car Hauler',
  [EmploymentEquipmentType.YARD_TRUCK]: 'Yard Truck',
}

/**
 * Canonical display order for equipment types.
 * Most common / general types first, specialty types last.
 * This ensures pills always appear in the same visual order across entries,
 * making it easy to scan who has what experience at a glance.
 */
const EQUIPMENT_SORT_ORDER: Record<string, number> = {
  [EmploymentEquipmentType.TRACTOR_TRAILER]: 0,
  [EmploymentEquipmentType.DRY_VAN]: 1,
  [EmploymentEquipmentType.REEFER]: 2,
  [EmploymentEquipmentType.FLATBED]: 3,
  [EmploymentEquipmentType.TANKER]: 4,
  [EmploymentEquipmentType.STEP_DECK]: 5,
  [EmploymentEquipmentType.RGN]: 6,
  [EmploymentEquipmentType.STRAIGHT_TRUCK]: 7,
  [EmploymentEquipmentType.DUMP_TRUCK]: 8,
  [EmploymentEquipmentType.SIDE_DUMP]: 9,
  [EmploymentEquipmentType.DOUBLES_AND_TRIPLES]: 10,
  [EmploymentEquipmentType.CONTAINER_CHASSIS]: 11,
  [EmploymentEquipmentType.CAR_HAULER]: 12,
  [EmploymentEquipmentType.BUS]: 13,
  [EmploymentEquipmentType.YARD_TRUCK]: 14,
}

/**
 * Sorts equipment types into a consistent display order.
 * Unknown types are pushed to the end.
 */
export const sortEquipmentTypes = (types: string[]): string[] => {
  return [...types].sort(
    (a, b) => (EQUIPMENT_SORT_ORDER[a] ?? 99) - (EQUIPMENT_SORT_ORDER[b] ?? 99)
  )
}

export const formatEmploymentEquipmentType = (value: string) => {
  if (!value) return value

  return (
    EmploymentEquipmentTypeLabels[value as EmploymentEquipmentType] ??
    value
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (letter) => letter.toUpperCase())
  )
}
